import { CheckIcon, FileIcon, MarkIcon } from "@/components/icons";
import { HERO_EXAMPLE } from "@/lib/landing";

/**
 * The hero's example: a resume, and the application it has already
 * filled in, with the person left to take it from there. Drawn, not a
 * form: nothing in it can be typed in or sent.
 */
export default function HeroFill() {
    return (
        <figure
            aria-label={`${HERO_EXAMPLE.tag}: ${HERO_EXAMPLE.eyebrow}`}
            className="m-0 flex min-w-0 flex-col gap-4 rounded-[24px] bg-hero-panel p-6 max-[760px]:p-5"
        >
            <p className="m-0 text-[12.5px] font-bold uppercase tracking-[0.18em] text-brand-ink">
                {HERO_EXAMPLE.eyebrow}
            </p>
            <div className="flex items-start gap-3">
                <span className="flex min-w-0 items-center gap-3 rounded-[14px] bg-card px-3 py-2.5 shadow-card">
                    <span className="relative grid size-10 shrink-0 place-items-center rounded-[10px] bg-card-raised text-fg-faint">
                        <FileIcon className="size-6" strokeWidth={1.6} />
                        <span className="absolute -bottom-1 -right-1 rounded-[5px] bg-tint-green px-1 font-mono text-[9.5px] font-bold text-brand-ink">
                            PDF
                        </span>
                    </span>
                    <span className="truncate text-[14.5px] text-fg">{HERO_EXAMPLE.file}</span>
                </span>
                {/* The resume goes into the form below it. */}
                <svg
                    viewBox="0 0 44 36"
                    aria-hidden="true"
                    className="mt-4 h-9 w-11 shrink-0 text-green"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M2 4h24a10 10 0 0 1 10 10v18M30 26l6 6 6-6" />
                </svg>
            </div>
            <div className="flex flex-col gap-3 rounded-[18px] bg-card p-5 shadow-sheet max-[760px]:p-4">
                <div className="flex items-baseline justify-between gap-3">
                    <span className="font-display text-[21px] font-bold tracking-[-0.02em] text-fg">
                        {HERO_EXAMPLE.title}
                    </span>
                    <span className="text-[12.5px] text-fg-muted">{HERO_EXAMPLE.tag}</span>
                </div>
                {HERO_EXAMPLE.fields.map((field) => (
                    <div key={field.label} className="flex flex-col gap-1.5">
                        <span className="text-[13px] text-fg-muted">{field.label}</span>
                        <span className="flex h-11 items-center justify-between gap-3 rounded-[10px] border border-line-control px-3.5 text-[15px] text-fg">
                            <span className="truncate">{field.value}</span>
                            <span className="grid size-7 shrink-0 place-items-center rounded-full bg-tint-green text-brand-ink">
                                <CheckIcon className="size-3.5" strokeWidth={2.6} />
                            </span>
                        </span>
                    </div>
                ))}
                <div className="mt-1 flex items-center gap-3 border-t border-line pt-4">
                    <span className="grid size-10 shrink-0 place-items-center rounded-[10px] bg-tint-green text-fg">
                        <MarkIcon className="size-5" fill="currentColor" />
                    </span>
                    <span className="text-[14.5px] font-medium text-brand-ink">
                        {HERO_EXAMPLE.done}
                    </span>
                </div>
            </div>
        </figure>
    );
}
